import {
    createApi,
    fakeBaseQuery,
} from '@reduxjs/toolkit/query';
import {
    AbstractedHardwareOverviewResponse,
    GladosEndpointVersion,
    GladosServiceFactory,
    HardwareOverviewParamsV1,
    HardwareType,
} from '@vfde-sails/glados-v2';
import { getQueryParam } from '@vfde-sails/utils';
import {
    selectManufacturer,
    selectSalesChannel,
    selectSubscriptionId,
} from '../features/app/slice';
import { RootState } from '../app/store';
import { getDefaultSubscriptionIds } from '../features/app/helpers/getDevicesPayloadHelper';
import {
    API_BTX_BNT,
    MAP_SALESCHANNEL_TO_API_SALESCHANNEL,
} from '@vfde-sails/constants';
import { isAxiosError } from 'axios';
import { RequestError } from '@vfde-sails/types';

const createRequestError = (error: unknown): RequestError => {
    if (isAxiosError(error)) {
        return {
            code: error.code,
            status: error.response?.status,
            message: error.message,
        };
    }

    return {
        message: error instanceof Error ? error.message : `${error}`,
    };
};

export const gladosApi = createApi({
    reducerPath: 'Glados',
    baseQuery: fakeBaseQuery<RequestError>(),
    endpoints: build => ({
        getHardwareOverview: build.query<AbstractedHardwareOverviewResponse, void>({
            queryFn: async (_arg, api) => {
                const hardwareService = GladosServiceFactory.getHardwareService();



                const state = api.getState() as RootState;
                const manufacturer = selectManufacturer(state);
                const subscriptionId = selectSubscriptionId(state);
                const salesChannel = selectSalesChannel(state);

                const tariffIds: HardwareOverviewParamsV1['tariffIds'] = subscriptionId
                    ? [subscriptionId]
                    : (getDefaultSubscriptionIds(salesChannel!) as HardwareOverviewParamsV1['tariffIds']);

                const params: HardwareOverviewParamsV1 = {
                    btx: API_BTX_BNT,
                    salesChannel: [MAP_SALESCHANNEL_TO_API_SALESCHANNEL[salesChannel!]],
                    hardwareTypes: [HardwareType.Smartphone],
                    category: HardwareType.Smartphone.toLowerCase(),
                    manufacturer,
                    tariffIds,
                };

                try {
                    const response = await hardwareService.getHardwareOverview(GladosEndpointVersion.V1, params);



                    return { data: response.data };
                }
                catch (error) {
                    return {
                        error: createRequestError(error),
                    };
                }
            },
        }),
    }),
});

export const {
    getHardwareOverview,
} = gladosApi.endpoints;
